import ProductList from '@frontend/features/product-list/ProductList'
import { ShopLoader } from '@frontend/features/shop/components/ShopLoader'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import { useUserStore } from '@frontend/libs/stores/useUserStore'
import { cn } from '@nextui-org/react'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'

function Loader() {
  const { shopGridView } = useUserStore((state) => state)
  return (
    <div
      className={cn(`grid grid-cols-2 gap-x-4 gap-y-6`, {
        'md:grid-cols-3': shopGridView === 'three-col',
        'md:grid-cols-4': shopGridView === 'four-col',
      })}
    >
      <ShopLoader />
    </div>
  )
}

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error } = usePostBySlug('shop')

  if (error) {
    toast.error('Failed to fetch shop page')
    showBoundary(error)
  }

  if (post) {
    document.title = post.meta.title

    const styleTag = document.getElementById('core-block-supports-inline-css')

    if (styleTag) {
      styleTag.innerHTML = post.styles
    } else {
      const style = document.createElement('style')
      style.id = 'core-block-supports-inline-css'
      document.head.appendChild(style)
      style.innerHTML = post.styles
    }
  }

  return <ProductList type="default" />
}

export function Shop() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default Shop
